import { Component, OnInit, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Product } from '../../../agatextscreens/purchasing/products/product';
import { ProductService } from '../../../agatextscreens/purchasing/products/product.service';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';

import { MdDialogRef, MdCheckbox } from '@angular/material';
import { Utils } from '../../../shared/utils';
import { Branch } from '../../../agatextscreens/accounting/branch';
import { BranchService } from '../../../agatextscreens/accounting/branches/branch.service';


@Component({
  selector: 'app-date-and-product-select-dialog',
  templateUrl: './date-and-product-select-dialog.component.html',
  styleUrls: ['./date-and-product-select-dialog.component.scss']
})
export class DateAndProductSelectDialogComponent implements OnInit, OnDestroy {

  constructor(
    public _authService: AuthenticationService,
    private _productService: ProductService,
    private _dialogRef: MdDialogRef<DateAndProductSelectDialogComponent>,
    private _branchService: BranchService) { }

  subscription: Subscription = new Subscription();
  from: string;
  prod: string;

  allBranches$: Observable<Branch[]>;
  selectedBranch: number = 0;

  allProducts: Product[] = [];
  matchingProducts: Product[] = [];

  selectedProduct: Product;

  ngOnInit() {

    this.allBranches$ = this._branchService.getBranches();

    console.log('requesting all branches');
    this.allBranches$.subscribe(
      response => {
        console.log('all branches returned');
        // Default to home branch
        this.selectedBranch = this._authService.getHomeBranch();
      }
    );

    this.subscription.add(this._productService
      .getProducts()
      .subscribe((products: Product[]) => {
        this.allProducts = products;
        this.matchingProducts = products.slice(0,100);

        //this._loadingService.resolve('loading');
      })
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  setSelected(product: Product) {
    this.selectedProduct = product;
  }


  filterProducts(input: string) {

    console.log('input: ' + input);

      this.matchingProducts = this.allProducts.filter(
        (prod: Product) => {
          let full_name = prod.collection_name + ' - ' + prod.design_name + '/' + prod.name;
          return full_name.toLowerCase().includes(input.toLowerCase());
        }
      ).slice(0,100);

  }

  close(result: {from: string, colorId: number, branchId: number, fullName: string}) {
    console.log(result ? 'from: ' + result.from + ', color id: ' + result.colorId + ', branch id: ' + result.branchId + ', full Name: ' + result.fullName: 'No Result');
    this._dialogRef.close(result);
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component.ts